var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"operation-helper"},[_c('Heading',{staticClass:"operation-helper__title",attrs:{"level":3}},[_vm._v(_vm._s(_vm.title))]),_c('BaseText',{attrs:{"size":"sm","color":_vm.NebraskaColors.textSecondary}},[_vm._v(_vm._s(_vm.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }